package com.evoapps.evoshift.di

import com.evoapps.evoshift.billing.RevenueCatKeys
import com.evoapps.evoshift.billing.WebBillingRepository
import com.evoapps.evoshift.billing.billingFor
import com.evoapps.evoshift.domain.repository.BillingRepository
import com.evoapps.evoshift.util.appLanguage
import com.evoapps.evoshift.domain.model.DevicePlatform
import com.evoapps.evoshift.auth.WebAppleSignInClient
import com.evoapps.evoshift.auth.WebGoogleSignInClient
import com.evoapps.evoshift.domain.provider.AppleSignInClient
import com.evoapps.evoshift.domain.provider.DeviceInfoProvider
import com.evoapps.evoshift.domain.provider.GoogleSignInClient
import com.evoapps.evoshift.observability.TelemetryBackend
import com.evoapps.evoshift.observability.TelemetryPlatform
import com.evoapps.evoshift.observability.WebTelemetryBackend
import com.evoapps.evoshift.observability.webTelemetryPlatform
import com.evoapps.evoshift.ui.reports.FileSaver
import com.evoapps.evoshift.ui.reports.WebFileSaver
import org.kodein.di.DI
import org.kodein.di.bind
import org.kodein.di.singleton

actual fun platformModule() = DI.Module("platformModule") {
    bind<DeviceInfoProvider>() with singleton {
        object : DeviceInfoProvider {
            override fun getLanguage(): String = appLanguage()
            override suspend fun getFcmToken(): String? = null
            override fun getDeviceName(): String = "Web Browser"
            override fun getPlatform(): DevicePlatform = DevicePlatform.WEB
        }
    }
    bind<GoogleSignInClient>() with singleton { WebGoogleSignInClient() }
    // Sign in with Apple through Firebase's apple.com popup (SH-92).
    bind<AppleSignInClient>() with singleton { WebAppleSignInClient() }
    // RevenueCat Web Billing (SH-38); no key = not configured.
    bind<BillingRepository>() with singleton { billingFor(RevenueCatKeys.WEB, ::WebBillingRepository) }
    // Analytics JS only after consent (SH-86); no Crashlytics on the web; never on localhost.
    bind<TelemetryBackend>() with singleton { WebTelemetryBackend() }
    bind<TelemetryPlatform>() with singleton { webTelemetryPlatform() }
    // Exported files (the hours for the accountant, SH-56).
    // SH-240: ?utm_source= / ?utm_campaign= / ?ref= of the address the app was opened with.
    bind<com.evoapps.evoshift.domain.provider.SignupSourceProvider>() with singleton {
        com.evoapps.evoshift.domain.provider.SignupSourceProvider { com.evoapps.evoshift.WebSignupSource.captured }
    }
    bind<FileSaver>() with singleton { WebFileSaver() }
    bind<com.evoapps.evoshift.documents.DocumentOpener>() with singleton { com.evoapps.evoshift.documents.WebDocumentOpener() }
}
